module.exports = __webpack_public_path__ + "img/Carla Manalo.f13df1d2.jpg";